export const scrollToPageTop = (
  browserWindow = typeof window === "undefined" ? null : window,
) => {
  browserWindow?.scrollTo(0, 0);
};
